import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import {
    OrderVolumeProfileElement,
    OrderVolumeProfileTimeSeriesData,
    OrderVolumeProfileTimeSeriesElement,
} from '../../api/OrderVolumeProfileElement';
import {
    initialOrderVolumeProfileDataState,
    initialOrderVolumeProfileStreamState,
    OrderVolumeProfileDataState,
    OrderVolumeProfileStreamedDataStreamState,
    OrderVolumeProfileStreamState,
} from './OrderVolumeProfileDataState';
import {
    createByStreamKeyReducer,
    createProcessStreamByStreamKeyDataMessage,
} from 'streamsState/store/streamedData/createByStreamKeyReducer';
import { StreamMessageElement } from 'communication/types/StreamElement';
import { WidgetStreamMessagesState } from 'widgets/store/stream/WidgetStreamState';
import timeSeriesReducer from 'utils/timeseries/timeSeriesUtils';
import { StreamElementType } from 'communication/types/StreamElementType';
import streamMessagesReducer from 'utils/messages/StreamMessage';
import omitUndefined from 'utils/omitUndefined';

const processOrderVolumeProfileDataStreamElement = (
    element: OrderVolumeProfileElement,
    nextDataState: OrderVolumeProfileDataState,
    nextMessagesState: WidgetStreamMessagesState
) => {
    timeSeriesReducer(
        element as OrderVolumeProfileTimeSeriesElement<StreamElementType>,
        nextDataState,
        mapToTimeSeriesItem
    );
    streamMessagesReducer(element as StreamMessageElement, nextMessagesState);
};

const processDataStreamElement = (
    element: OrderVolumeProfileElement,
    nextState: OrderVolumeProfileStreamedDataStreamState
) => {
    const nextDataState = nextState.data ?? {
        ...initialOrderVolumeProfileDataState,
    };
    processOrderVolumeProfileDataStreamElement(
        element,
        nextDataState,
        nextState
    );
};

const processDataStreamMessage = createProcessStreamByStreamKeyDataMessage<
    OrderVolumeProfileDataState,
    OrderVolumeProfileElement,
    OrderVolumeProfileStreamedDataStreamState
>(processDataStreamElement);

export const selectOrderVolumeProfileStreamRequestBySymbolStreamedData = (
    state: State
) => selectStreamedDataState(state).orderVolumeProfile;

export const orderVolumeProfileStreamDataReducer = createByStreamKeyReducer<
    OrderVolumeProfileDataState,
    OrderVolumeProfileElement,
    OrderVolumeProfileStreamState
>(
    'startOrderVolumeCurveStream',
    initialOrderVolumeProfileStreamState,
    processDataStreamMessage
);

export function mapToTimeSeriesItem<T>(
    from: OrderVolumeProfileTimeSeriesElement<T>
): OrderVolumeProfileTimeSeriesData {
    return omitUndefined({
        _i: from._i,
        auctionEndMinute: from.auctionEndMinute,
        auctionId: from.auctionId,
        auctionName: from.auctionName,
        auctRawWgt: from.auctRawWgt,
        auctVol: from.auctVol,
        auctWgt: from.auctWgt,
        contRawWgt: from.contRawWgt,
        contVol: from.contVol,
        contWgt: from.contWgt,
        cumVol: from.cumVol,
        cumWgt: from.cumWgt,
        rawWgt: from.rawWgt,
        sessionId: from.sessionId,
        sessionName: from.sessionName,
        vol: from.vol,
        wgt: from.wgt,
    });
}
